function ErrorComponent() {
  return <div>Unable to load invoices</div>;
}

export default ErrorComponent;
